import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'classnames';
import { useClickOutside } from '../../utils/func';

/**
 * Modern PopoverHelper component using React hooks
 * Compatible with React 17+ and provides click-outside and Escape-to-close handling
 * @returns {JSX.Element} The popover helper component
 */
const PopoverHelperV2 = ({ id, show, closePopover, className, children }) => {
	const popoverRef = useRef(null);

	// Use the modern click outside hook
	useClickOutside(popoverRef, () => {
		if (show) {
			closePopover(id);
		}
	}, [show, id]);

	useEffect(() => {
		if (!show) return undefined;
		const onKeyDown = (event) => {
			if (event.key === 'Escape') {
				closePopover(id);
			}
		};
		document.addEventListener('keydown', onKeyDown);
		return () => document.removeEventListener('keydown', onKeyDown);
	}, [show, id, closePopover]);

	return (
		<div
			id={id}
			ref={popoverRef}
			className={cx('popover-helper', {'display-none': !show}, className)}
		>
			{_.map(children, child => child)}
		</div>
	);
};

PopoverHelperV2.propTypes = {
	id: PropTypes.string.isRequired,
	show: PropTypes.bool.isRequired,
	closePopover: PropTypes.func.isRequired,
	className: PropTypes.string,
	children: PropTypes.node
};

export default PopoverHelperV2;
